export default "<div class=\"spinner-container\">\n  <div class=\"spinner\"></div>\n</div>";